import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import {
  changeStatusMarca,
  deleteMarca,
  getMarcas,
} from "../../../../api/marca";
import FiltersCard from "../../../components/filters/Filter";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  InputLabel,
  makeStyles,
  Switch,
  TextField,
  Tooltip,
} from "@material-ui/core";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import { Autocomplete } from "@material-ui/lab";
import {
  Edit,
} from "@material-ui/icons";
import { shallowEqual, useSelector } from "react-redux";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";

function getData(marcas) {
  let data = [];
  
  // Calcular suma de porcentajes de marcas prioritarias ACTIVAS
  const sumaPorcentajesPrioritarios = marcas
    .filter(m => m.prioritaria === true && m.active !== false)
    .reduce((sum, m) => sum + (m.scrapingPercent || 0), 0);
  
  // Contar marcas no prioritarias ACTIVAS (solo las que participan en el scraping)
  const cantidadMarcasNoPrioritarias = marcas.filter(m => !m.prioritaria && m.active !== false).length;
  
  // Calcular porcentaje para marcas no prioritarias (solo entre las activas)
  const porcentajeNoPrioritarias = cantidadMarcasNoPrioritarias > 0
    ? (100 - sumaPorcentajesPrioritarios) / cantidadMarcasNoPrioritarias
    : 0;
  
  for (let i = 0; i < marcas.length; ++i) {
    const elem = {};
    elem.nombre = marcas[i]?.nombre;
    elem.active = marcas[i]?.active;
    elem.web = marcas[i]?.web;
    elem.createdAt = marcas[i]?.createdAt;
    elem.id = marcas[i]?._id;
    elem.discountPercent = marcas[i]?.discountPercent ?? 0;
    elem.prioritaria = marcas[i]?.prioritaria ?? false;
    
    // Calcular porcentaje de scraping
    // Si la marca está desactivada, poner scrapingPercent a 0
    if (marcas[i]?.active === false) {
      elem.scrapingPercent = 0;
    } else if (marcas[i]?.prioritaria) {
      // Si es prioritaria, usar el scrapingPercent configurado (o 0 si no está configurado)
      elem.scrapingPercent = marcas[i]?.scrapingPercent ?? 0;
    } else {
      // Si no es prioritaria, calcular el porcentaje equitativo
      elem.scrapingPercent = porcentajeNoPrioritarias;
    }
    
    data = data.concat(elem);
  }
  return data;
}

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
    overflow: "hidden",
  },
  fancyLoader: {
    color: "#AF9A51 ",
    animation: `$spin 1s linear infinite`,
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function MarcasPage() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [marca, setMarca] = useState({});
  const [marcaId, setMarcaId] = useState("");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const history = useHistory();
  const classes = useStyles();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const columns = [
    { dataField: "nombre", text: "Nombre", sort: true },
    { dataField: "discountPercent", text: "Descuento %", formatter: (cell) => (cell != null ? `${cell}%` : "0%") },
    { dataField: "scrapingPercent", text: "Scraping %", formatter: (cell, row) => {
      // Si la marca está desactivada, mostrar 0%
      const percent = row?.active === false ? 0 : (cell != null ? parseFloat(cell).toFixed(2) : "0.00");
      const isPrioritaria = row?.prioritaria;
      return (
        <span>
          {percent}%
          {isPrioritaria && <span style={{ color: "#AF9A51", marginLeft: "5px" }}>⭐</span>}
        </span>
      );
    }},
    { dataField: "createdAt", text: "Fecha", formatter: dateFormatter },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-marca/" + cell)}
          >
            <Edit />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setMarca(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setMarca(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  useEffect(() => {
    setLoading(true);
    getMarcas()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setLoading(false);
          setRefresh(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({ error: error, customMessage: "Could not get marcas." });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Lista Marcas">
          <CardHeaderToolbar>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-marca")}
            >
              Add
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={getData(filteredData)} columns={columns} />
          <ConfirmDialog
            title={`Are you sure you want to ${marca?.active ? "disable" : "enable"
              } this brand?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusMarca(marca?._id, !marca?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${marca?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `Brand ${marca?.active ? "disabled" : "enabled"
                        } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${marca?.active ? "disable" : "enable"
                      } brand.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this brand?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteMarca(marca?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Brand removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove brand.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
